/* eslint-disable import/prefer-default-export */
import { textTruncate } from '@utils/textHelper';
import { emptyList, emptyObject } from '@constants/empty';

export const getBadgeUrl = (level) => {
  return `educator/dpp-revamp/level-badges/edu-badge-level-${level}.svg`;
};

export const getTrimmedName = (name) => textTruncate(name, 20);

export const getCardInfoList = (info = emptyObject) => {
  if (info.overallStats) {
    const cardsInfo = info.overallStats?.[0].stats;

    if (cardsInfo) {
      return [
        {
          title: 'PRACTICES PUBLISHED',
          value: cardsInfo.publishedDppCount,
          bgImageUrl: 'educator/dpp-revamp/card-bg-practices-published.png'
        },
        {
          title: 'LEARNER ATTEMPTS',
          value: cardsInfo.attemptCount,
          bgImageUrl: 'educator/dpp-revamp/card-bg-learner-attempts.png'
        },
        {
          title: 'EDUCATORS',
          value: cardsInfo.educatorCount,
          bgImageUrl: 'educator/dpp-revamp/card-bg-educators.png'
        }
      ];
    }
    return emptyList;
  }
  return emptyList;
};
